import {
  ApplicationConfig,
  inject,
  InjectionToken,
  Injector,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

import { routes } from './app.routes';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EnvironmentService } from './services/enviroment/environment.service';
import { finalize, take } from 'rxjs';
import { LOCATION_INITIALIZED } from '@angular/common';
import { PropertiesService } from './services/properties/properties.service';
import { RestInterceptor } from './services/interceptors/rest.interceptor';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initConfig() {
  return () => {
    const config = inject(EnvironmentService);
    return config.loadConfig();
  };
}

export function initProps() {
  return () => {
    const props = inject(PropertiesService);
    props.loadProps();
  };
}

export function appInitializerFactory() {
  return () => {
    const injectorRef = inject(Injector);
    const translate = inject(TranslateService);
    new Promise<unknown>((resolve: any) => {
      console.log(LOCATION_INITIALIZED);
      const locationInitialized = injectorRef.get(
        LOCATION_INITIALIZED,
        Promise.resolve(null)
      );
      locationInitialized.then(() => {
        const langToSet = 'es';
        translate.setDefaultLang(langToSet);

        translate
          .use(langToSet)
          .pipe(
            take(1),
            finalize(() => resolve(null))
          )
          .subscribe();
      });
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([RestInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    provideAppInitializer(initConfig()),
    provideAppInitializer(initProps()),
    provideAppInitializer(appInitializerFactory()),
  ],
};
